<div class="center-content">
    <h2 mat-dialog-title>Are you sure ?</h2>
    <div mat-dialog-content style="width: 100%; margin: 0px">
        <h5>{{text}}</h5>
    </div>
    <mat-dialog-actions align="center">
        <button mat-button (click)="confirm()">Ok</button>
    </mat-dialog-actions>
</div>
